import type { ApproveInvoiceResponse } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { UUID } from '~/types/common';

import { vestigasApi } from '~/services/kyClient';

import { zodInvoiceDetailSchema } from '../useQueryInvoiceDetail/validations';

/**
 * Approves an invoice.
 *
 * The API re-runs the formality checks first and answers 409 when a result
 * differs from the last completed run, keeping that run and leaving the
 * invoice unapproved.
 *
 * @param invoiceId - Invoice identifier.
 * @returns The invoice detail after approval.
 * @see https://app.dev.vestigas.com/redoc#tag/Invoices/operation/approve_invoice_invoices__invoice_id__approve_post
 */
export async function approveInvoice(invoiceId: UUID) {
  return vestigasApi
    .post(ENDPOINT.INVOICE.APPROVE(invoiceId), {
      validate: {
        isResponseSensitive: true,
        response: zodInvoiceDetailSchema,
      },
    })
    .json<ApproveInvoiceResponse>();
}
